module.exports = __webpack_public_path__ + "img/line-child5.3ad9c763.png";